// @mui
import { enUS, esES, deDE, frFR, itIT, ptBR, ptPT } from '@mui/material/locale';
import SpainFlag from 'src/assets/flags/ES.svg';
import USFlag from 'src/assets/flags/US.svg';
import MxFlag from 'src/assets/flags/MEX.svg';
import FrFlag from 'src/assets/flags/FR.svg';
import DeFlag from 'src/assets/flags/DE.svg';
import ItFlag from 'src/assets/flags/IT.svg';
import BrFlag from 'src/assets/flags/BR.png';
import PtFlag from 'src/assets/flags/PT.png';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Spanish',
    value: 'es',
    systemValue: esES,
    icon: SpainFlag,
    showLabel: 'ES'
  },
  {
    label: 'Latam Spanish',
    value: 'es_mx',
    systemValue: esES,
    icon: MxFlag,
    showLabel: 'MX'
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: USFlag,
    showLabel: 'EN'
  },
  {
    label: 'Germany',
    value: 'de',
    systemValue: deDE,
    icon: DeFlag,
    showLabel: 'DE'
  }, {
    label: 'France',
    value: 'fr',
    systemValue: frFR,
    icon: FrFlag,
    showLabel: 'FR'
  },
  {
    label: 'Italy',
    value: 'it',
    systemValue: itIT,
    icon: ItFlag,
    showLabel: 'IT'
  },
  {
    label: 'Brazil',
    value: 'br',
    systemValue: ptBR,
    icon: BrFlag,
    showLabel: 'BR'
  },
  {
    label: 'Portugal',
    value: 'pt',
    systemValue: ptPT,
    icon: PtFlag,
    showLabel: 'PT'
  }

];

export const defaultLang = allLangs[0]; // spanish
